import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'izin-kaydi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule, NzDatePickerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="mk-edit">
      <div class="mk-baslik">
        <div class="mk-baslik-ikon" style="background:linear-gradient(135deg,#059669,#34d399)">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        </div>
        <span>İzin Kaydı</span>
      </div>
      <div class="mk-form">
        <div class="form-grup">
          <label>İzin Türü <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select [ngModel]="deger('izinTuru') || 'Yıllık'" (ngModelChange)="guncelle('izinTuru', $event)" style="width:100%">
              <nz-option nzValue="Yıllık" nzLabel="Yıllık" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#22c55e"></span>Yıllık</span></nz-option>
              <nz-option nzValue="Mazeret" nzLabel="Mazeret" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#f59e0b"></span>Mazeret</span></nz-option>
              <nz-option nzValue="Rapor" nzLabel="Rapor" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#3b82f6"></span>Rapor</span></nz-option>
              <nz-option nzValue="Ücretsiz" nzLabel="Ücretsiz" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#94a3b8"></span>Ücretsiz</span></nz-option>
            </nz-select>
            <div class="input-glow"></div>
          </div>
        </div>
        <div class="form-satir">
          <div class="form-grup">
            <label>Başlangıç <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-date-picker [ngModel]="deger('baslangic')" (ngModelChange)="guncelle('baslangic', $event)" style="width:100%" nzFormat="dd.MM.yyyy"></nz-date-picker>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Bitiş <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-date-picker [ngModel]="deger('bitis')" (ngModelChange)="guncelle('bitis', $event)" style="width:100%" nzFormat="dd.MM.yyyy"></nz-date-picker>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
        <div class="form-satir">
          <div class="form-grup">
            <label>Gün Sayısı</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('gun') || 1" (ngModelChange)="guncelle('gun', $event)" [nzMin]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Durum</label>
            <div class="input-wrap">
              <nz-select [ngModel]="deger('durum') || 'Bekliyor'" (ngModelChange)="guncelle('durum', $event)" style="width:100%">
                <nz-option nzValue="Bekliyor" nzLabel="Bekliyor" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#94a3b8"></span>Bekliyor</span></nz-option>
                <nz-option nzValue="Onaylandı" nzLabel="Onaylandı" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#22c55e"></span>Onaylandı</span></nz-option>
                <nz-option nzValue="Reddedildi" nzLabel="Reddedildi" nzCustomContent><span class="ac-opt"><span class="ac-dot" style="background:#ef4444"></span>Reddedildi</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }
    .mk-edit { display: flex; flex-direction: column; padding: 0; }
    .mk-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .mk-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(5,150,105,0.35); }
    .mk-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .mk-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #059669, #34d399, #059669); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap ::ng-deep .ant-select-selector, .input-wrap ::ng-deep .ant-picker { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
    .input-wrap ::ng-deep .ant-input-number { width: 100% !important; border-radius: 8px; }
    .ac-opt { display: flex; align-items: center; gap: 8px; }
    .ac-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
  `],
})
export class IzinKaydiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
